import React from 'react';
import styled from '@emotion/styled';
import fontWoff from 'src/assets/fonts/icons.woff';
import { observer } from 'src/utils/mobx-react';

const config = {
    'addPlus': 59933,
    'arrowDown': 59912,
    'arrowUp': 59934,
    'arrowUpMove': 59923,
    'calendar': 59905,
    'chart': 59936,
    'checkedIcon': 59929,
    'checkmark': 59907,
    'closeIcon': 59909,
    'cog': 59926,
    'down': 59911,
    'downArrow': 59924,
    'exit': 59916,
    'football': 59914,
    'gift': 59931,
    'info': 59913,
    'infoIcon': 59917,
    'infoLine': 59920,
    'leftArrow': 59938,
    'loupe': 59930,
    'notPermitted': 59915,
    'pen': 59906,
    'phone': 59922,
    'rename': 59910,
    'rightArrow': 59927,
    'save': 59928,
    'shape': 59935,
    'tableGames': 59919,
    'time': 59937,
    'trashcan': 59921,
    'up': 59908,
    'upArrow': 59932,
    'verticalMove': 59925,
    'warning': 59918
};

type ConfigKeyType = keyof typeof config;

export const fontCssForIcon = `
    @font-face {
        font-family: icons;
        font-weight: normal;
        font-display: block;
        src: url(${fontWoff}) format('woff');
    }
`;

interface SpanWrapperPropsType {
    color: string | undefined
}

const SpanWrapper = styled('span', { label: 'SpanWrapper' })<SpanWrapperPropsType>`
    font-family: icons;
    ${({ color }): string => color === undefined ? '' : `color: ${color};`}

    svg {
      fill: currentColor;
      height: 1em;
      width: auto;
    }
`;

function getIconContent(name: ConfigKeyType): string | null {
    const charValue = config[name];

    if (!charValue) {
        return null;
    }

    return String.fromCharCode(charValue);
}

interface IconPropsType {
    className?: string,
    name: ConfigKeyType,
    color?: string,
    children?: React.ReactNode,
}

const Icon = observer('Icon', (props: IconPropsType) => {
    const { name, color, children, className } = props;
    const content = getIconContent(name);

    if (content === null) {
        return (
            <span className='icon icon--not-found' />
        );
    }

    return (
        <SpanWrapper
            className={`icon icon--${name} ${className}`}
            color={color}
        >
            { children }
            { content }
        </SpanWrapper>
    );
});

export default Icon;
